import { LineupService, type LineupSlot, type LineupSlotOccupant } from '../../services/LineupService';

export const VALID_TACTICS = [
  '1-3-4-3',
  '1-3-5-2',
  '1-4-3-3',
  '1-4-4-2',
  '1-4-5-1',
  '1-5-3-2',
  '1-5-4-1',
];

type PitchSlot = LineupSlot<LineupSlotOccupant>;

export interface LineupRow {
  role: string;
  slots: PitchSlot[];
}

const ROLE_RENDER_ORDER = ['DELANTERO', 'CENTROCAMPISTA', 'DEFENSA', 'PORTERO'];

export const buildLineupRows = (lineup: PitchSlot[], tactics: string): LineupRow[] => {
  const distribution = LineupService.parseTactics(tactics);
  const roleRanges: Record<string, PitchSlot[]> = {};
  let currentPosition = 1;

  ['PORTERO', 'DEFENSA', 'CENTROCAMPISTA', 'DELANTERO'].forEach((role) => {
    const count = distribution[role] ?? 0;
    roleRanges[role] = lineup.slice(currentPosition - 1, currentPosition - 1 + count);
    currentPosition += count;
  });

  return ROLE_RENDER_ORDER.map((role) => ({
    role,
    slots: roleRanges[role] ?? [],
  })).filter((row) => row.slots.length > 0);
};
